import { SHAPES_MASTER_ELEMENTS as trans } from './translationValues';

export const shapesElements = t => {
  return [
    {
      id: 291,
      type: 'image',
      categoryId: 186,
      shareType: null,
      thumbnail: '/square.svg',
      name: t(`SHAPES_MASTER_ELEMENTS:${trans.SQUARE_LABEL.key}`, trans.SQUARE_LABEL.value),
      tags: null,
      resourceGroup: 0,
      permission: 'write',
      referenced: false,
      element: {
        tagValue: '/square.svg',
        uiType: 'rectangle',
        styles: {
          backgroundColor: 'transparent',
          transform: 'translateX(1) translateY(1) rotate(0deg) scaleX(1) scaleY(1)',
          position: 'absolute',
        },
        type: 'image',
        tagName: 'image',
        value: '/square.svg',
        tagStyles: {
          scaleX: 1,
          scaleY: 1,
          rotate: 0,
          backgroundColor: [255, 255, 255, 1],
          translateY: 219,
          translateX: 24.75848388671875,
          width: '214',
          height: '214',
        },
      },
      groupId: null,
      language: null,
      elementJson: {
        empty: false,
      },
    },
    {
      id: 290,
      type: 'image',
      categoryId: 186,
      shareType: null,
      thumbnail: '/borderedRect.svg',
      name: t(
        `SHAPES_MASTER_ELEMENTS:${trans.BORDERED_RECTANGLE_LABEL.key}`,
        trans.BORDERED_RECTANGLE_LABEL.value,
      ),
      tags: null,
      resourceGroup: 0,
      permission: 'write',
      referenced: false,
      element: {
        tagValue: '/borderedRect.svg',
        uiType: 'rectangle',
        styles: {
          backgroundColor: 'transparent',
          transform: 'translateX(1) translateY(1) rotate(0deg) scaleX(1) scaleY(1)',
          position: 'absolute',
        },
        type: 'image',
        tagName: 'image',
        value: '/borderedRect.svg',
        tagStyles: {
          scaleX: 1,
          scaleY: 1,
          rotate: 0,
          backgroundColor: [255, 255, 255, 1],
          translateY: 219,
          translateX: 24.75848388671875,
          width: '419.25',
          height: '297.75',
        },
      },
      groupId: null,
      language: null,
      elementJson: {
        empty: false,
      },
    },
    {
      id: 289,
      type: 'image',
      categoryId: 186,
      shareType: null,
      thumbnail: '/roundedRect.svg',
      name: t(
        `SHAPES_MASTER_ELEMENTS:${trans.ROUNDED_RECTANGLE_LABEL.key}`,
        trans.ROUNDED_RECTANGLE_LABEL.value,
      ),
      tags: null,
      resourceGroup: 0,
      permission: 'write',
      referenced: false,
      element: {
        tagValue: '/roundedRect.svg',
        uiType: 'rectangle',
        styles: {
          backgroundColor: 'transparent',
          transform: 'translateX(1) translateY(1) rotate(0deg) scaleX(1) scaleY(1)',
          position: 'absolute',
        },
        type: 'image',
        tagName: 'image',
        value: '/roundedRect.svg',
        tagStyles: {
          scaleX: 1,
          scaleY: 1,
          rotate: 0,
          backgroundColor: [255, 255, 255, 1],
          translateY: 219,
          translateX: 24.75848388671875,
          width: '419.25',
          height: '297.75',
        },
      },
      groupId: null,
      language: null,
      elementJson: {
        empty: false,
      },
    },
    {
      id: 288,
      type: 'image',
      categoryId: 186,
      shareType: null,
      thumbnail: '/rect.svg',
      name: t(`SHAPES_MASTER_ELEMENTS:${trans.RECTANGLE_LABEL.key}`, trans.RECTANGLE_LABEL.value),
      tags: null,
      resourceGroup: 0,
      permission: 'write',
      referenced: false,
      element: {
        tagValue: '/rect.svg',
        uiType: 'rectangle',
        styles: {
          backgroundColor: 'transparent',
          transform: 'translateX(1) translateY(1) rotate(0deg) scaleX(1) scaleY(1)',
          position: 'absolute',
        },
        type: 'image',
        tagName: 'image',
        value: '/rect.svg',
        tagStyles: {
          scaleX: 1,
          scaleY: 1,
          rotate: 0,
          backgroundColor: [255, 255, 255, 1],
          translateY: 219,
          translateX: 24.75848388671875,
          width: '100.0239712450144',
          height: '217.8292848442666',
        },
      },
      groupId: null,
      language: null,
      elementJson: {
        empty: false,
      },
    },
    {
      id: 304,
      type: 'image',
      categoryId: 186,
      shareType: null,
      thumbnail: '/circle.svg',
      name: t(`SHAPES_MASTER_ELEMENTS:${trans.CIRCLE_LABEL.key}`, trans.CIRCLE_LABEL.value),
      tags: null,
      resourceGroup: 0,
      permission: 'write',
      referenced: false,
      element: {
        tagValue: '/circle.svg',
        uiType: 'circle',
        styles: {
          backgroundColor: 'transparent',
          transform: 'translateX(1) translateY(1) rotate(0deg) scaleX(1) scaleY(1)',
          position: 'absolute',
          width: '300',
          height: '300',
        },
        type: 'image',
        tagName: 'image',
        value: '/circle.svg',
        tagStyles: {
          scaleX: 1,
          scaleY: 1,
          rotate: 0,
          backgroundColor: [255, 255, 255, 1],
          translateY: 219,
          translateX: 24.75848388671875,
          width: '300',
          height: '300',
        },
      },
      groupId: null,
      language: null,
      elementJson: {
        empty: false,
      },
    },
  ];
};
